import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer">
            <p>&copy;  2021 C3 Programming Center, All Rights Reserved. Design By RIDOY</p>
            <i className="fab fa-facebook"></i>
            <i className="fab fa-twitter mx-3"></i>
            <i class="fab fa-dribbble"></i>
            <i class="fab fa-linkedin-in mx-3"></i>
        </div>
    );
};

export default Footer;